// extracted by mini-css-extract-plugin
export default {"boxEntitySubTitle":"BoxSubTitle_boxEntitySubTitle__M2Omk","subTitleBold":"BoxSubTitle_subTitleBold__cttZK"};